import "./PaginationTableLite.scss";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";

function PaginationTableLite(props: any) {
  let totalPages = Math.ceil(props.recordCount / props.limit);
  const maxButtonCount = 10;
  const halfMax = Math.floor(maxButtonCount / 2);
  const startPage = Math.max(props.currentPage - halfMax, 1);
  const endPage = Math.min(startPage + maxButtonCount - 1, totalPages == 1 ? 0 : totalPages);
  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  // ページ数に変更があった場合に、最初のページに遷移
  useEffect(() => {
    if (totalPages == 0) return;
    if (props.currentPage > totalPages) {
      props.setCurrentPage(1);
    } else {
      props.setCurrentPage(props.currentPage);
    }
  }, [props, totalPages]);

  const handlePageChange = (pageNumber: number) => {
    props.setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (props.currentPage < Math.ceil(props.recordCount / props.limit)) {
      props.setCurrentPage(props.currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (props.currentPage > 1) {
      props.setCurrentPage(props.currentPage - 1);
    }
  };

  return (
    <>
      <div className={props.isUnnecessary ? "" : "plate"} style={{ textAlign: "center" }}>
        <Table
          id={
            props.tr_select == false
              ? "pagination_table_no_select"
              : "pagination_table_select"
          }
          style={{
            maxWidth: props.max_width || 1300,
          }}
        >
          <thead>
            <tr>
              {props.headers.map((x: string, i: number) => (
                <th key={i}>{x}</th>
              ))}
            </tr>
          </thead>
          <tbody>{props.list}</tbody>
        </Table>
        {pageNumbers.length > 0 && (
          <div
            className="d-flex justify-content-center"
            style={{ maxWidth: props.max_width }}
          >
            <Pagination>
              {props.currentPage > 1 && (
                <>
                  <Pagination.Prev onClick={handlePrevPage} />
                  {startPage > 1 && (
                    <>
                      <Pagination.Item onClick={() => handlePageChange(1)}>
                        1
                      </Pagination.Item>
                      {startPage > 2 && <Pagination.Ellipsis disabled />}
                    </>
                  )}
                </>
              )}
              {pageNumbers.map((pageNumber) => (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === props.currentPage}
                  onClick={() => {
                    handlePageChange(pageNumber);
                  }}
                >
                  {pageNumber}
                </Pagination.Item>
              ))}
              {endPage < totalPages && (
                <>
                  {endPage < totalPages - 1 && <Pagination.Ellipsis disabled />}
                  {props.currentPage !== totalPages && (
                    <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                      {totalPages}
                    </Pagination.Item>
                  )}
                  <Pagination.Next onClick={handleNextPage} />
                </>
              )}
            </Pagination>
          </div>
        )}
      </div>
    </>
  );
}

export default PaginationTableLite;
